(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].umd = global["dist/index"].umd || {}, global["dist/index"].umd.js = factory()));
})(this, (function () { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function (d, b) {
      extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      };
      return extendStatics(d, b);
    };
    function __extends(d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
      return t;
    }

    /**
    * 获取点击dom上的日志信息
    * @param  {Object} node  点击的dom
    * @param  {Object} wrap  查找的dom范围
    * @return {boolean}      返回dom上的日志信息
    */
    function getClickLogDomData(node, wrap) {
        var hasLink = false;
        var xpath = [];
        try {
            while (node && node !== wrap) {
                // 有data-nolog属性标记时，无需自动发日志，无需dom日志信息
                if (node.hasAttribute('data-nolog')) {
                    return;
                }
                ;
                node.tagName === 'A' && (hasLink = true);
                var siblingDomNum = getSiblingDomNum(node);
                // 获取click-module数据
                var moduleName = node.getAttribute('click-module');
                moduleName = moduleName ? '(' + moduleName + ')' : '';
                xpath.push(node.nodeName.toLowerCase() + (siblingDomNum > 1 ? siblingDomNum : '') + moduleName);
                node = node.parentNode;
            }
            // 无a标签时，无需自动发日志，无需dom日志信息
            if (!hasLink) {
                return;
            }
            return {
                // 暂时先只加xpath，后续集成data-log等
                xpath: xpath.reverse().join('-')
            };
        }
        catch (e) {
            return;
        }
    }
    /**
    * 获取当前dom在同级别Dom中的序列数
    * @param  {Object} node 要查询的dom
    * @return {number}      返回同级别Dom序列数
    */
    function getSiblingDomNum(node) {
        var sibling = node.previousSibling;
        var count = 1;
        while (sibling) {
            if (sibling.nodeType === 1 && sibling.nodeName === node.nodeName) {
                count++;
            }
            sibling = sibling.previousSibling;
        }
        return count;
    }

    var SearchLog = /** @class */ (function () {
        function SearchLog(pd, page) {
            // source标识日志来自于哪里（新c页为landing)
            this.source = 'landing';
            this.pd = pd;
            this.page = page;
            this.bindOnClick = this.onClick.bind(this);
        }
        SearchLog.prototype.initDomClick = function (el, sendLog) {
            if (!el || typeof sendLog !== 'function') {
                return;
            }
            this.sendLogFn = sendLog;
            this.clickWrap = el;
            el.addEventListener('click', this.bindOnClick, false);
        };
        SearchLog.prototype.onClick = function (event) {
            if (event && event.target) {
                var el = event.target;
                // 获取xpath等dom上的日志信息
                var domData = getClickLogDomData(el, this.clickWrap);
                if (domData && this.sendLogFn) {
                    this.sendLogFn({
                        clk_info: domData
                    });
                }
            }
        };
        SearchLog.prototype.removeDomClick = function (el) {
            if (el) {
                el.removeEventListener('click', this.bindOnClick);
            }
        };
        return SearchLog;
    }());

    var TcLog = /** @class */ (function (_super) {
        __extends(TcLog, _super);
        function TcLog(tcLogParams) {
            var _this = this;
            var pd = tcLogParams.pd, page = tcLogParams.page, lid = tcLogParams.lid, applid = tcLogParams.applid;
            _this = _super.call(this, pd, page) || this;
            _this.lid = lid;
            _this.applid = applid;
            return _this;
        }
        TcLog.prototype.sendLog = function (extraParams) {
            if (extraParams === void 0) { extraParams = {}; }
            // tc 日志都发送到 m.baidu.com 域下（不区分 PC/wise）
            var url = '//m.baidu.com/tc';
            var request = new Image();
            request.src = "".concat(url, "?").concat(this.paramsParser(extraParams));
        };
        TcLog.prototype.paramsParser = function (logParams) {
            var baseParams = __assign(__assign({}, (logParams.ct ? {} : { module: this.source })), { pd: this.pd, atn: this.page, lid: this.lid, applid: this.applid, tcreq4log: 1 });
            var _a = logParams, _b = _a.extra, extra = _b === void 0 ? {} : _b, clk_info = _a.clk_info, partParams = __rest(_a, ["extra", "clk_info"]);
            var finalParams = __assign(__assign(__assign(__assign({}, baseParams), partParams), (clk_info ? { clk_info: JSON.stringify(clk_info) } : {})), (logParams.ct
                ? { clk_extra: JSON.stringify(extra) }
                : { extra: JSON.stringify(extra) }));
            var paramsStrArr = [];
            for (var i in finalParams) {
                if (finalParams.hasOwnProperty(i)) {
                    // @ts-ignore
                    paramsStrArr.push("".concat(i, "=").concat(encodeURIComponent(finalParams[i])));
                }
            }
            return paramsStrArr.join('&');
        };
        // 跳转日志
        TcLog.prototype.sendJumpLog = function (logParams) {
            if (logParams === void 0) { logParams = {}; }
            this.sendLog(__assign({ cyc: 1 }, logParams));
        };
        // 用户行为日志
        TcLog.prototype.sendActionLog = function (logParams) {
            // 行为日志独有参数需要做tc映射，以符合tc日志规范,用户自定义内容统一放在extra中
            var type = logParams.type, action = logParams.action, subpos = logParams.subpos, partParams = __rest(logParams, ["type", "action", "subpos"]);
            this.sendLog(__assign({ clk_info: {
                    type: type,
                    action: action,
                    subpos: subpos
                } }, partParams));
        };
        // 自定义日志（原中间页日志）
        TcLog.prototype.sendCustomeLog = function (logParams) {
            this.sendLog(__assign({ r: Date.now() }, logParams));
        };
        TcLog.prototype.initDomClickLog = function (el) {
            this.initDomClick(el, this.sendLog);
        };
        return TcLog;
    }(SearchLog));

    var index = {
        TcLog: TcLog
    };

    return index;

}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@baidu/search-log/dist/index.umd.js
// module id = vzKv
// module chunks = 0